import React from 'react'
import styles from './SummaryWidgetGroup.module.scss'

interface SummaryWidgetGroupProps {
  children: React.ReactNode
}

const SummaryWidgetGroup = ({ children }: SummaryWidgetGroupProps) => {
  return <div className={styles.root}>{children}</div>
}

export default SummaryWidgetGroup
